import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, watch} from "vue";
import Icon from "@/components/Icons/Icon.vue";

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchFilter',
  props: {
  modelValue: {
    type: [Number, String]
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit

// eslint-disable-next-line no-undef
const props = __props

const setSearchValue = ref(props.modelValue);

watch(() => props.modelValue, (newValue) => {
  setSearchValue.value = newValue;
});

watch(setSearchValue, (newValue) => {
  emit('update:modelValue', newValue);
});


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(_component_v_col, { cols: "12" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_text_field, {
        placeholder: "Search...",
        density: "compact",
        class: "input-round-20 mx-2",
        width: "100%",
        variant: "solo",
        elevation: "0",
        modelValue: setSearchValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((setSearchValue).value = $event)),
        "hide-details": "",
        rounded: ""
      }, {
        "prepend-inner": _withCtx(() => [
          _createVNode(Icon, {
            icon: "search-icon",
            color: "grey_light"
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})